const blogSelectors = {

};

class TemplateBlogArticleJS {
    constructor() {
        // Custom code for blog/article page goes here
    }
}

typeof TemplateBlogArticleJS !== 'undefined' && new TemplateBlogArticleJS();
